import React from 'react';
import { useCounter, Arrow } from './Home';

const services = [
  {
    accent:'accent-red', hover:'red-hover', icon:'red', color:'var(--red)',
    title:'BTL Marketing',
    body:'Strategic below-the-line campaigns tailored for educational environments — activations, sampling, stalls, and events.',
    tags:['Events','Activations','Sampling'],
    svg:<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M18 20V10M12 20V4M6 20v-6" stroke="#FF0032" strokeWidth="2.2" strokeLinecap="round"/></svg>,
  },
  {
    accent:'accent-blue', hover:'blue-hover', icon:'blue', color:'var(--blue)',
    title:'Brand–Institution Bridge',
    body:'Connecting brands and educational institutions for mutual growth — managing relationships on both sides.',
    tags:['Partnerships','Sponsorships','Tie-ups'],
    svg:<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="5" cy="12" r="2" fill="#0583F2"/><circle cx="19" cy="12" r="2" fill="#0583F2"/><path d="M7 12h10" stroke="#0583F2" strokeWidth="2" strokeLinecap="round"/><path d="M12 4v5M12 15v5" stroke="#0583F2" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2 2.5"/></svg>,
  },
  {
    accent:'accent-red', hover:'red-hover', icon:'red', color:'var(--red)',
    title:'Targeted Promotion',
    body:'Precision outreach to the right students at the right time — inside the spaces they already occupy.',
    tags:['Demographics','On-Ground','Digital'],
    svg:<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#FF0032" strokeWidth="1.5"/><circle cx="12" cy="12" r="5" stroke="#FF0032" strokeWidth="1.5"/><circle cx="12" cy="12" r="1.8" fill="#FF0032"/></svg>,
  },
];

function StatCard({ num, suffix, label, color }) {
  const ref = React.useRef(null);
  const [inView, setInView] = React.useState(false);
  React.useEffect(() => {
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold:.5 });
    if (ref.current) io.observe(ref.current);
    return () => io.disconnect();
  }, []);
  const val = useCounter(num, inView);
  return (
    <div ref={ref} className="card p-8 text-center red-hover">
      <div className="stat-num" style={{ color }}>{val.toLocaleString()}{suffix}</div>
      <div className="mt-3 text-white/45 text-sm font-medium">{label}</div>
    </div>
  );
}

export default function Services() {
  return (
    <section id="services" className="section bg-surface">
      <div className="max-w-content mx-auto">

        {/* Header */}
        <div className="max-w-2xl mb-16 reveal">
          <span className="label label-blue">Services</span>
          <h2 className="heading mt-5">What We <em style={{ color:'var(--blue)' }}>Do</em></h2>
          <div className="divider blue mt-5 mb-5 wide" />
          <p className="subtext text-base">
            We specialize in creating meaningful connections between brands
            and the vibrant campus community.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {services.map((s, i) => (
            <div key={s.title} className={`card ${s.accent} ${s.hover} reveal d${i+1} p-8 flex flex-col`}>
              <div className={`icon-box ${s.icon} mb-6`}>{s.svg}</div>
              <h3 className="text-white font-bold text-lg mb-3">{s.title}</h3>
              <p className="subtext text-sm leading-relaxed mb-5 flex-1">{s.body}</p>
              <div className="flex flex-wrap gap-2 mb-5">
                {s.tags.map(t => <span key={t} className="tag">{t}</span>)}
              </div>
              <div className="flex items-center gap-2 text-sm font-semibold" style={{ color: s.color }}>
                Learn more <Arrow />
              </div>
            </div>
          ))}
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          <StatCard num="50"     suffix="+" label="Partner Institutions"  color="var(--red)"  />
          <StatCard num="100"    suffix="+" label="Brand Collaborations"  color="var(--blue)" />
          <StatCard num="500000" suffix="+" label="Students Reached"      color="var(--red)"  />
          <StatCard num="95"     suffix="%" label="Client Satisfaction"   color="var(--blue)" />
        </div>
      </div>
    </section>
  );
}
